var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('ul', {
    staticClass: "bottom-navigation"
  }, [_c('li', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'home'
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("@/assets/icons/home.svg")
    }
  })])], 1), _vm.can('create-patient,view-patient') ? _c('li', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'registration'
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("@/assets/icons/report.svg")
    }
  })])], 1) : _vm._e(), _vm.can('entry-checkup') ? _c('li', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'diseases-factors'
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("@/assets/icons/beer.svg")
    }
  })])], 1) : _vm._e(), _vm.can('entry-checkup') ? _c('li', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'measurement'
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("@/assets/icons/ruler.svg")
    }
  })])], 1) : _vm._e(), _vm.can('entry-checkup') ? _c('li', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'checkup'
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("@/assets/icons/flask.svg")
    }
  })])], 1) : _vm._e(), _vm.can('entry-checkup') ? _c('li', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'consultation'
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("@/assets/icons/consultation.svg")
    }
  })])], 1) : _vm._e(), _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": _vm.openSettingBottomSheet
    }
  }, [_c('img', {
    attrs: {
      "src": require("@/assets/icons/menu.svg")
    }
  })])])]), _c('bottom-sheet', {
    attrs: {
      "show": _vm.settingBottomSheet,
      "on-close": _vm.closeSettingBottomSheet
    },
    on: {
      "update:show": function updateShow($event) {
        _vm.settingBottomSheet = $event;
      }
    }
  }, [_c('span', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("Lainnya")]), _c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_c('ul', {
    staticClass: "list-menu"
  }, [_vm.can('view-report') ? _c('li', {
    staticClass: "pointer",
    on: {
      "click": _vm.gotoReportPage
    }
  }, [_c('material-icon', {
    attrs: {
      "name": "show_chart",
      "size": "20"
    }
  }), _vm._v(" Rekapitulasi\n        ")], 1) : _vm._e(), _vm.can('create-operator,view-operator') ? _c('li', {
    staticClass: "pointer",
    on: {
      "click": _vm.gotoOperatorPage
    }
  }, [_c('material-icon', {
    attrs: {
      "name": "supervisor_account",
      "size": "20"
    }
  }), _vm._v(" Operator\n        ")], 1) : _vm._e(), _c('li', {
    staticClass: "pointer",
    on: {
      "click": _vm.gotoSettingPage
    }
  }, [_c('material-icon', {
    attrs: {
      "name": "person",
      "size": "20"
    }
  }), _vm._v(" Profil & Pengaturan\n        ")], 1), _vm.can('view-mental-health-participant,update-mental-health-checkup,create-mental-health-schedule,update-mental-health-schedule,delete-mental-health-schedule') ? _c('li', {
    staticClass: "header"
  }, [_vm._v("\n          Layanan Konsultasi Psikologi\n        ")]) : _vm._e(), _vm.can('view-mental-health-participant,update-mental-health-checkup') ? _c('li', {
    staticClass: "pointer",
    on: {
      "click": _vm.gotoMentalHealthPage
    }
  }, [_c('material-icon', {
    attrs: {
      "name": "psychology",
      "type": "rounded",
      "size": "20"
    }
  }), _vm._v("\n          Pendaftar\n        ")], 1) : _vm._e(), _vm.can('create-mental-health-schedule,update-mental-health-schedule,delete-mental-health-schedule') ? _c('li', {
    staticClass: "pointer",
    on: {
      "click": _vm.gotoMentalHealthSchedulePage
    }
  }, [_c('material-icon', {
    attrs: {
      "name": "calendar_month",
      "type": "outlined",
      "size": "20"
    }
  }), _vm._v("\n          Jadwal Konsultasi\n        ")], 1) : _vm._e(), _vm.can('create-mental-health-room,update-mental-health-room,delete-mental-health-room') ? _c('li', {
    staticClass: "pointer",
    on: {
      "click": _vm.gotoMentalHealthRoomPage
    }
  }, [_c('material-icon', {
    attrs: {
      "name": "chair",
      "type": "outlined",
      "size": "20"
    }
  }), _vm._v("\n          Ruang\n        ")], 1) : _vm._e(), _vm.can('create-mental-health-psychologist,update-mental-health-psychologist') ? _c('li', {
    staticClass: "pointer",
    on: {
      "click": _vm.gotoMentalHealthPsychologistPage
    }
  }, [_c('material-icon', {
    attrs: {
      "name": "assignment_ind",
      "type": "outlined",
      "size": "20"
    }
  }), _vm._v("\n          Psikolog\n        ")], 1) : _vm._e(), _c('li', {
    staticClass: "pointer text-danger",
    on: {
      "click": _vm.doLogout
    }
  }, [_c('material-icon', {
    attrs: {
      "name": "exit_to_app",
      "size": "20"
    }
  }), _vm._v(" Keluar\n        ")], 1)])])])], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }